"use client";

import { Analytics as VercelAnalytics } from "@vercel/analytics/react";
import { isProd } from "@/lib/utils";

export function Analytics() {
  return isProd ? <VercelAnalytics mode="production" /> : null;
}
